import { Node, nodeInputRule } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { Plugin } from '@tiptap/pm/state';

import VariableComponent from './VariableComponent';

const VARIABLE_REGEX_INPUT = /(\{\{\s*([^}]+?)\s*\}\})$/;
const VARIABLE_REGEX_PASTE = /(\{\{\s*([^}]+?)\s*\}\})/g;

export default Node.create({
    name: 'variable',
    group: 'inline',
    inline: true,
    atom: true,

    addOptions() {
        return {
            variableMap: {},
        };
    },

    addAttributes() {
        return {
            key: {
                default: '',
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span[data-variable]',
                getAttrs: (dom) => ({
                    key: dom.getAttribute('data-variable'),
                }),
            },
        ];
    },

    renderText({ node }) {
        return `{{ ${node.attrs.key} }}`;
    },

    renderHTML({ node }) {
        return ['span', { 'data-variable': node.attrs.key }, `{{ ${node.attrs.key} }}`];
    },

    addCommands() {
        return {
            insertVariable:
                (key) =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: this.name,
                        attrs: { key },
                    });
                },
        };
    },

    addInputRules() {
        return [
            nodeInputRule({
                find: VARIABLE_REGEX_INPUT,
                type: this.type,
                getAttributes: (match) => {
                    const [, , key] = match;
                    return { key: key.trim() };
                },
            }),
        ];
    },

    addPasteRules() {
        return [
            nodeInputRule({
                find: VARIABLE_REGEX_PASTE,
                type: this.type,
                getAttributes: (match) => {
                    const [, , key] = match;
                    return { key: key.trim() };
                },
            }),
        ];
    },

    addProseMirrorPlugins() {
        let initialized = false;
        return [
            new Plugin({
                appendTransaction: (_transactions, _oldState, newState) => {
                    if (initialized) return null;
                    initialized = true;

                    const { tr } = newState;
                    let modified = false;
                    const replacements = [];
                    newState.doc.descendants((node, pos) => {
                        if (!node.isText) return;

                        const regex = /\{\{\s*([^}]+?)\s*\}\}/g;
                        let match;

                        while ((match = regex.exec(node.text)) !== null) {
                            const start = pos + match.index;
                            const end = start + match[0].length;
                            const key = match[1].trim();

                            replacements.push({
                                start,
                                end,
                                key,
                            });
                        }
                    });

                    // Apply replacements in reverse order to maintain positions and avoid crashes
                    replacements
                        .sort((a, b) => b.start - a.start)
                        .forEach(({ start, end, key }) => {
                            tr.replaceWith(
                                start,
                                end,
                                newState.schema.nodes.variable.create({ key }),
                            );
                            modified = true;
                        });

                    return modified ? tr : null;
                },
            }),
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(VariableComponent);
    },
});
